<template>
  <div class="login">
    <div class="banner">
      <div class="banner-inner">
        <div class="forminner active">
          <ul class="nav">
            <li class="active register">立即注册</li>
          </ul>
          <div class="form register active">
            <input type="text" v-model="form.phone" placeholder="请输入您的手机号">
            <div class="code">
              <input type="text" v-model="form.code" placeholder="请输入验证码">
              <span v-show="show" @click="getCode">获取验证码</span>
              <span v-show="!show" class="count">{{count}} s</span>
            </div>
            <input type="password"  v-model="form.password" placeholder="请输入密码">
            <input type="password" v-model="form.passwords" placeholder="请再次输入密码">
            <div class="loginbut active" @click="login">登 录</div>
            <router-link class="password" to="/login">已有账号，立即登陆</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {membersend,memberregister} from '@/api/login'
    export default {
      data(){
        return {
          form:{
            phone:'',
            type:'register',
            code:'',
            password:'',
            passwords:''
          },
          show: true,
          count: '',
          timer: null,
        }
      },
      methods:{
        getCode(){
          if (this.form.phone == '') {
            alert('请输入手机号')
            return false;
          }
          if (this.form.phone.length != 11) {
            alert('请输入正确的手机号')
            return false;
          }
          membersend(this.form).then((res) => {
            console.log(res);
            if(res.code==200){
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.show = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000)
              }
            }
          })
        },
        login(){
          if (this.form.phone == '') {
            alert('请输入手机号')
            return false;
          }
          if (this.form.phone.length != 11) {
            alert('请输入正确的手机号')
            return false;
          }
          if(this.form.code==''){
            alert('请输入验证码')
            return false;
          }
          if(this.form.password==''){
            alert('请输入密码')
            return false;
          }
          if(this.form.password==''){
            alert('请再次输入密码')
            return false;
          }
          if(this.form.password!=this.form.passwords){
            alert('二次密码输入不一致')
            return false;
          }
          memberregister(this.form).then((res) => {
            if(res.code==200){
              alert('注册成功');
              this.$router.push({path:'/login'})
            }
          })
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../style/login.scss";
</style>




// WEBPACK FOOTER //
// src/view/login/register.vue